import React, { useState, useEffect } from 'react';
import { Info } from 'lucide-react';
import dataService from '../../services/dataService';

// Production data (program name, parts produced, cycle time) comes from a
// machine with monitorKind === 'cnc'. No CNC firmware writes the v2 schema yet,
// so this page has no data source — render an honest empty state.
const ProductionDashboard = () => {
  const [machines, setMachines] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = dataService.subscribeAllMachines((data, err) => {
      if (!err && data) setMachines(data);
      setLoading(false);
    });
    return () => { if (typeof unsub === 'function') unsub(); };
  }, []);

  const cncMachines = machines.filter((m) => m.monitorKind === 'cnc');

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-8 h-8 border-2 border-brand-500/30 border-t-brand-500 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="section-title">Production</h1>
        <p className="section-subtitle">Program, parts, cycle time — from CNC-monitored machines only</p>
      </div>

      <div className="card p-8 flex flex-col items-center justify-center text-center">
        <Info className="w-10 h-10 text-slate-500 mb-3" />
        <h3 className="text-sm font-semibold text-slate-200 mb-1">No production data available</h3>
        <p className="text-xs text-slate-400 max-w-md">
          Production metrics (program name, part count, cycle time, efficiency) come from a CNC's
          ethernet interface. {cncMachines.length === 0
            ? 'No machines in the fleet currently have monitorKind = "cnc".'
            : `${cncMachines.length} CNC-bound machine(s) exist, but the v2 schema for CNC isn't being written yet.`}
        </p>
        <p className="text-[11px] text-slate-500 mt-3">
          Analog and digital boards have no CNC interface and cannot report production.
        </p>
      </div>
    </div>
  );
};

export default ProductionDashboard;
